import { render, staticRenderFns } from "./materialList.vue?vue&type=template&id=37d6aa28&scoped=true&"
import script from "./materialList.vue?vue&type=script&lang=js&"
export * from "./materialList.vue?vue&type=script&lang=js&"
import style0 from "@assets/css/index/index.less?vue&type=style&index=0&id=37d6aa28&lang=less&scoped=true&"
import style1 from "./materialList.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d6aa28",
  null
  
)

component.options.__file = "materialList.vue"
export default component.exports